if (!window.dwcSpecImageLightboxInitialised) {
  window.dwcSpecImageLightboxInitialised = true;

  const readPixelVariable = (element, name, fallback) => {
    const value = Number.parseFloat(getComputedStyle(element).getPropertyValue(name));
    return Number.isFinite(value) ? value : fallback;
  };

  const sizeDialog = (dialog) => {
    const image = dialog?.querySelector('.dwc-spec-image-lightbox__image');
    if (!image?.naturalWidth || !image?.naturalHeight) return false;

    const configuredWindowSize = readPixelVariable(dialog, '--dwc-spec-lightbox-window-size', 1100);
    const configuredImageSize = readPixelVariable(dialog, '--dwc-spec-lightbox-image-max-size', 1000);
    const padding = Math.min(Math.max(readPixelVariable(dialog, '--dwc-spec-lightbox-padding', 20), 0), 50);
    const margin = Math.max(readPixelVariable(dialog, '--dwc-spec-lightbox-margin', 20), 0);
    const viewportSize = Math.min(window.innerWidth, window.innerHeight);
    const availableWindowSize = Math.max(1, viewportSize - margin * 2 - 2);
    const windowSizeLimit = Math.max(1, Math.min(configuredWindowSize, availableWindowSize));
    const imageSizeLimit = Math.max(1, Math.min(configuredImageSize, windowSizeLimit - padding * 2));
    const scale = Math.min(imageSizeLimit / image.naturalWidth, imageSizeLimit / image.naturalHeight);
    const renderedWidth = Math.max(1, Math.round(image.naturalWidth * scale));
    const renderedHeight = Math.max(1, Math.round(image.naturalHeight * scale));
    const renderedWindowSize = Math.min(windowSizeLimit, Math.max(renderedWidth, renderedHeight) + padding * 2);

    dialog.style.setProperty('--dwc-spec-lightbox-render-size', `${Math.round(renderedWindowSize)}px`);
    dialog.style.setProperty('--dwc-spec-lightbox-rendered-image-width', `${renderedWidth}px`);
    dialog.style.setProperty('--dwc-spec-lightbox-rendered-image-height', `${renderedHeight}px`);
    dialog.classList.remove('is-sizing');
    return true;
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-dwc-spec-image-open]');
    if (openTrigger) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = openTrigger.closest('.dwc-spec-image')?.querySelector('[data-dwc-spec-image-dialog]');
      if (!dialog?.showModal) return;
      event.preventDefault();
      dialog.classList.add('is-sizing');
      dialog.showModal();
      const image = dialog.querySelector('.dwc-spec-image-lightbox__image');
      const revealDialog = () => {
        if (!dialog.open) return;
        sizeDialog(dialog);
        dialog.querySelector('[data-dwc-spec-image-close]')?.focus();
      };
      if (image?.complete && image.naturalWidth) revealDialog();
      else image?.addEventListener('load', revealDialog, { once: true });
      return;
    }

    const closeTrigger = event.target.closest('[data-dwc-spec-image-close]');
    if (closeTrigger) {
      closeTrigger.closest('[data-dwc-spec-image-dialog]')?.close();
      return;
    }
    if (event.target.matches('[data-dwc-spec-image-dialog]')) event.target.close();
  });

  let resizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      document.querySelectorAll('[data-dwc-spec-image-dialog][open]').forEach(sizeDialog);
    });
  });
}
